<template>

  <div>

    <!-- Filters -->
    <UsersListFilters  />

    <!-- Table Container Card -->
    <BCard no-body class="mb-0" >

      <div class="m-2">

        <!-- Table Top -->
        <BRow>
          <!-- Per Page -->
          <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
            <label>{{$t('Show')}}</label>
            <vSelect v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{$t('entries')}}</label>
          </BCol>

          <!-- Search -->
          <BCol cols="12" md="8" lg="7" xl="6">
            <div class="d-flex align-items-center justify-content-end">
              <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'" /> -->
              <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BDropdown
                  id="dropdown-3"
                  text="Exportar"
                  variant="success"
                  class="mr-1"
                >
                  <BDropdownItem @click="download('PDF')">PDF</BDropdownItem>
                  <BDropdownItem @click="download('CSV')">CSV</BDropdownItem>
                  <BDropdownItem @click="download('XLS')">XLS</BDropdownItem>
                </BDropdown>
                <BButton variant="primary" :to="{name : 'users-add'}" v-if="ability.can('create', 'user')">
                <span class="text-nowrap">{{$t('Add User')}}</span>
              </BButton>
            </div>
          </BCol>
        </BRow>

      </div>

      <BTable ref="refUserListTable" class="position-relative" :items="fetchUsers" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc" >

        <!-- Column: User -->
        <template #cell(name)="data">
          <BMedia vertical-align="center">
            <template #aside>
              <BAvatar size="40" :src="data.item.avatar" :text="avatarText(data.item.full_name)" :variant="`light-${resolveUserRoleVariant(data.item.role)}`" :to="{ name: 'users-view', params: { id: data.item.id } }" />
            </template>
            <BLink :to="{ name: 'users-view', params: { id: data.item.id } }" class="font-weight-bold d-block text-nowrap" > {{ data.item.full_name }} </BLink>
            <small class="text-muted" v-if="data.item.username">@{{ data.item.username }}</small>
          </BMedia>
        </template>

        <!-- Column: Role -->
        <template #cell(roles)="data">
          <div class="text-nowrap" v-for="rol in data.item.roles" :key="rol.id">
            <feather-icon :icon="resolveUserRoleIcon(rol.name)" size="18" class="mr-50" :class="`text-${resolveUserRoleVariant(rol.name)}`" />
            <span class="align-text-top text-capitalize">{{ rol.name }}</span>
          </div>
        </template>

        <!-- Column: Group -->
        <template #cell(groups)="data">
          <span v-for="group in data.item.groups" :key="group.id">
            <BBadge variant="light-info" class="mr-1" :to="{ name: 'groups-view', params: { id: group.id } }" v-if="ability.can('read', 'group')">{{ group.name }}</BBadge>
            <BBadge variant="light-info" class="mr-1" :to="{ name: 'groups-view', params: { id: group.id } }" v-else>{{ group.name }}</BBadge>
          </span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <BBadge pill :variant="`light-${resolveUserStatusVariant(data.item.status)}`" class="text-capitalize" v-if="data.item.status == 1"> {{$t('Active')}} </BBadge>
          <BBadge pill :variant="`light-${resolveUserStatusVariant(data.item.status)}`" class="text-capitalize" v-else> {{$t('Inactive')}} </BBadge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <BDropdownItem :to="{ name: 'users-view', params: { id: data.item.id } }" v-if="ability.can('read', 'user')">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">{{$t('Details')}}</span>
            </BDropdownItem>

            <BDropdownItem :to="{ name: 'users-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'user')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{$t('Edit')}}</span>
            </BDropdownItem>

            <BDropdownItem @click="deletePopup(data.item.id, 'users/deleteUser')" v-if="ability.can('delete', 'user')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{$t('Delete')}}</span>
            </BDropdownItem>
          </BDropdown>
        </template>

      </BTable>
      <div class="mx-2 mb-2">
        <BRow>

          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
            <span class="text-muted">{{$t('Showing')}} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{$t('of')}} {{ dataMeta.of }} {{$t('entries')}}</span>
          </BCol>
          <!-- Pagination -->
          <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end" >

            <BPagination v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </BPagination>

          </BCol>

        </BRow>
      </div>
    </BCard>
  </div>

</template>

<script>
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,} from 'bootstrap-vue'
import { ref, onUnmounted, provide } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import UsersListFilters from './UsersListFilters.vue'
import userStoreModule from '../userStoreModule'
import useUsersList from './useUsersList'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import store from '@/store'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import exportUtils from '@/hooks/exportUtils'

export default {
    components: { UsersListFilters, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, TextInputValidated },
    setup(){
        const { exportData } = exportUtils()
        const { fetchUsers, tableColumns, perPage, currentPage, totalUsers, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refUserListTable, refetchData, resolveUserRoleVariant, resolveUserRoleIcon, resolveUserStatusVariant, roleFilter, groupFilter, statusFilter, roleOptions, groupOptions } = useUsersList()
        const { deletePopup, successToast, errorToast } = popups()
        const isAddNewUserSidebarActive = ref(false)
        const USERS_MODULE = 'users'

        const status = [
            { label: i18n.t('Active'), value: 1 },
            { label: i18n.t('Inactive'), value: 0 },
        ]

        provide('statusFilter', statusFilter),
        provide('groupFilter', groupFilter),
        provide('roleFilter', roleFilter)
        provide('status', status)
        provide('groups', groupOptions)
        provide('roles', roleOptions)

        if(!store.hasModule(USERS_MODULE)) store.registerModule(USERS_MODULE, userStoreModule)

        onUnmounted(() => {
            if(store.hasModule(USERS_MODULE)) store.unregisterModule(USERS_MODULE)
        })

        const download = function (type) {
          let data={
            q: searchQuery.value,
            role: roleFilter.value,
            group: groupFilter.value,
            status: statusFilter.value,
            type: type
          }

          exportData('/users/export', data, `listado_usuarios_${new Date(Date.now()).toLocaleDateString('es-ES')}` , type)
        }

        return {
            isAddNewUserSidebarActive,
            resolveUserStatusVariant,
            resolveUserRoleVariant,
            resolveUserRoleIcon,
            refUserListTable,
            perPageOptions,
            isSortDirDesc,
            tableColumns,
            searchQuery,
            currentPage,
            refetchData,
            deletePopup,
            totalUsers,
            fetchUsers,
            avatarText,
            dataMeta,
            perPage,
            sortBy,
            ability,
            download
        }

    }

}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
